;
define("cart_summary_gift_certificate_cell.tpl", function(){});

